import { createSelector } from 'reselect';

import { ROUTES } from '../../common';
import getMatch from '../match/matchSelector';
import { ReduxState } from '../../common/types';

export const getSearchTerm = (state: ReduxState) => state.searchTerm;

const getSearchTermForPath = (path: string) =>
  createSelector(getMatch, getSearchTerm, (matchObj, searchTerm) => {
    // FIXME: this is a hack because of missing matchObj
    if (localStorage.worklistActive === 'true') return searchTerm;
    if (matchObj && matchObj.path === path) return searchTerm;
    return '';
  });

export const getSearchTermForWorklist = createSelector(
  getSearchTermForPath(ROUTES.worklist),
  (searchTerm) => searchTerm
);
